import { isArray } from '@antv/util';
/** @ignore */
export function parseFields(field) {
    if (isArray(field)) {
        return field;
    }
    return field.split('*');
}
//# sourceMappingURL=parse-fields.js.map